import React from 'react';
import { useDefaultCardData } from 'constants/cardDefaults';
import { CardGroup, InfoCard } from 'library';

const UseCaseCardsBlock = ({ title, text }) => {
  const useCaseCards = useDefaultCardData({ cardType: 'allUseCases' });

  return (
    <CardGroup cardSize={InfoCard.size} title={title} text={text}>
      {useCaseCards.map((data, key) => {
        return <InfoCard {...data} key={key} />;
      })}
    </CardGroup>
  );
};

export default UseCaseCardsBlock;
